import type { Notifier } from '@/plugins/notifier';
import { inject } from 'vue';

export function useNotification() {
  const snotify = inject<Notifier>('$snotify');

  if (!snotify) {
    throw new Error('Notifier plugin not found. Make sure the notifier plugin is installed.');
  }

  return {
    notifySuccess: (message: string) => snotify.success(message),
    notifyWarning: (message: string) => snotify.warning(message),
    notifyError: (message: string, options?: Parameters<Notifier['error']>[1]) => snotify.error(message, options),
  };
}
